import { useForm, UseFormReturnType } from '@mantine/form';
import { useState } from 'react';

import { looksLikeEmail } from '@/helpers/validators';

type FormValues = {
  email: string;
};

type UseSignInEmail = () => {
  form: UseFormReturnType<FormValues>;
  next: boolean;
  back: () => void;
  onSubmit: () => void;
  canProceed: boolean;
};

const useSignInEmail: UseSignInEmail = () => {
  const form = useForm<FormValues>({
    initialValues: {
      email: '',
    },
    validate: {
      email: looksLikeEmail('Invalid email'),
    },
  });
  const [next, setNext] = useState(false);

  const onSubmit = form.onSubmit(() => setNext(true));

  return {
    form,
    next,
    back: () => setNext(false),
    onSubmit,
    canProceed: !form.values.email || next,
  };
};

export default useSignInEmail;
